<template>
	<section class="stats">
		<PrimeAccordion>
			<PrimeAccordionPanel value="users">
				<PrimeAccordionHeader>Users</PrimeAccordionHeader>
				<PrimeAccordionContent class="stats-group">
					<PrimeCard v-if="isPageReady">
						<template #title>
							Users (monthly, via interactions with images) for last 12 months
						</template>
						<template #content>
							<StatsMonthlyUsersChart :chartOptions />
						</template>
					</PrimeCard>
					<PrimeCard v-if="isPageReady">
						<template #title>
							Users (daily, via interactions with images) for last 30 days
						</template>
						<template #content>
							<StatsDailyUsersChart :chartOptions />
						</template>
					</PrimeCard>
				</PrimeAccordionContent>
			</PrimeAccordionPanel>

			<PrimeDivider type="dotted" />

			<PrimeAccordionPanel value="images">
				<PrimeAccordionHeader>Images</PrimeAccordionHeader>
				<PrimeAccordionContent class="stats-group">
					<PrimeCard v-if="isPageReady">
						<template #title>Images count (monthly)</template>
						<template #content>
							<StatsMonthlyImagesCountChart :chartOptions />
						</template>
					</PrimeCard>
				</PrimeAccordionContent>
			</PrimeAccordionPanel>

			<PrimeDivider type="dotted" />

			<PrimeAccordionPanel value="cameras_and_lenses">
				<PrimeAccordionHeader>Cameras and Lenses</PrimeAccordionHeader>
				<PrimeAccordionContent class="stats-group">
					<PrimeCard v-if="isPageReady" style="flex-basis: 100%">
						<template #title>Top cameras (with lenses used) for last month</template>
						<template #content>
							<StatsMonthlyCamerasTopTable />
						</template>
					</PrimeCard>
				</PrimeAccordionContent>
			</PrimeAccordionPanel>
		</PrimeAccordion>
	</section>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";

import PrimeAccordion from "primevue/accordion";
import PrimeAccordionPanel from "primevue/accordionpanel";
import PrimeAccordionHeader from "primevue/accordionheader";
import PrimeAccordionContent from "primevue/accordioncontent";
import PrimeCard from "primevue/card";
import PrimeDivider from "primevue/divider";

// Users
import StatsMonthlyUsersChart from "./stats/StatsMonthlyUsersChart.vue";
import StatsDailyUsersChart from "./stats/StatsDailyUsersChart.vue";

// Images
import StatsMonthlyImagesCountChart from "./stats/StatsMonthlyImagesCountChart.vue";

// Cameras
import StatsMonthlyCamerasTopTable from "./stats/StatsMonthlyCameraLensesTopTable.vue";

export default defineComponent({
	name: "StatsView",
	components: {
		PrimeAccordion,
		PrimeAccordionPanel,
		PrimeAccordionHeader,
		PrimeAccordionContent,
		PrimeCard,
		PrimeDivider,

		//

		StatsMonthlyUsersChart,
		StatsDailyUsersChart,

		StatsMonthlyImagesCountChart,

		StatsMonthlyCamerasTopTable
	},

	setup() {
		const isPageReady = ref(false);
		const chartOptions = ref();

		const setChartOptions = () => {
			const documentStyle = getComputedStyle(document.documentElement);
			const textColorSecondary = documentStyle.getPropertyValue("--p-text-muted-color");
			const surfaceBorder = documentStyle.getPropertyValue("--p-content-border-color");

			return {
				responsive: true,
				plugins: {
					legend: {
						display: false
					}
				},
				scales: {
					x: {
						ticks: {
							color: textColorSecondary
						},
						grid: {
							color: surfaceBorder
						}
					},
					y: {
						beginAtZero: true,
						ticks: {
							color: textColorSecondary
						},
						grid: {
							color: surfaceBorder
						}
					}
				}
			};
		};

		onMounted(async () => {
			chartOptions.value = setChartOptions();
			isPageReady.value = true;
		});

		return {
			isPageReady,
			chartOptions
		};
	}
});
</script>
<style lang="scss" scoped>
.stats {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;

	> * {
		width: 100%;
	}

	.stats-group {
		@media only screen and (max-width: 760px) {
			flex-direction: column;
		}

		> * {
			display: flex;
			flex-direction: row;
			width: 100%;
			gap: 16px;
			flex-grow: 1;

			> * {
				flex-basis: 50%;
			}
		}
	}
}
</style>
